import { useParams } from 'react-router-dom';
import PageMeta from '@/components/feature/PageMeta';
import SiteLayout from '@/components/feature/SiteLayout';
import { categoryMeta } from '@/mocks/categories';
import CategoryListPage from '@/pages/category/components/CategoryListPage';

interface CategoryPageProps {
  type: 'movie' | 'tv' | 'variety';
}

export default function CategoryPage({ type }: CategoryPageProps) {
  const params = useParams();
  const current = categoryMeta[params.type ?? type] ?? categoryMeta[type];

  return (
    <PageMeta
      title={`${current.label} - 91在线视频 - 高清影视在线播放平台`}
      description={`91在线视频${current.label}频道，收录最新上线的${current.label}作品，支持按类型、地区、年份筛选与排序，快速找到想看的${current.label}。`}
      keywords={`${current.label},${current.label}在线观看,91在线视频,高清${current.label},影视资源`}
    >
      <SiteLayout padded>
        <CategoryListPage key={current.key} type={current.key} />
      </SiteLayout>
    </PageMeta>
  );
}